import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject, catchError, distinctUntilChanged, map, of, startWith, switchMap } from 'rxjs';
import { TimesheetParsed } from '../../models/timesheet';
import { TimesheetService } from '../timesheet.service';
import { T7eService } from '../../t7e/t7e.service';

type PrevTsState = {
  isLoading?: boolean;
  ts?: TimesheetParsed | null;
  error?: string;
};

@Component({
  selector: 'app-prev-ts-dialog',
  templateUrl: './prev-ts-dialog.component.html',
  styleUrls: ['./prev-ts-dialog.component.scss']
})
export class PrevTsDialogComponent {
  readonly dateFormat = 'yyyy. MMM dd.'

  t7eLoadError = this.t7e.getTranslation('app-prev-ts-dialog', 'load-error', 'innerText', null, null, 'Hiba történt az előző napi TS lekérése közben')

  private readonly _tsId$ = new BehaviorSubject<number | null>(null)

  @Input()
  set tsId(value: number | null | undefined) {
    this._tsId$.next(value ?? null)
  }

  @Output() closed = new EventEmitter<void>()

  readonly state$ = this._tsId$.pipe(
    distinctUntilChanged(),
    switchMap(tsId => !tsId ? of(null) : this.tsSvc.listTsOfPrevDay(tsId).pipe(
      map((x): PrevTsState => ({ isLoading: false, ts: x?.length !== 1 ? null : x[0] })),
      startWith<PrevTsState>({ isLoading: true }),
      catchError(err => of<PrevTsState>({ isLoading: false, error: err.message || this.t7eLoadError })),
    )),
  )

  constructor(
    private tsSvc: TimesheetService,
    private t7e: T7eService,
  ) { }

  onDialogClose(): void {
    this.closed.emit()
  }
}
